const Vision = () => {
   return (
      <div className="main-text">
         <h5>Vision</h5>
         <p>
            Man bun PBR&B keytar copper mug prism, hell of helvetica. Synth
            crucifix offal deep v hella biodiesel. Church-key listicle polaroid
            put a bird on it chillwave palo santo enamel pin, tattooed meggings
            franzen la croix cray. Retro yr aesthetic four loko tbh helvetica
            air plant, neutra palo santo tofu mumblecore. Hoodie bushwick
            pour-over jean shorts chartreuse shabby chic. Roof party hammock
            master cleanse pop-up truffaut, bicycle rights skateboard affogato
            readymade sustainable deep v live-edge schlitz narwhal.
         </p>
         <ul className="vision-list">
            <li>list item</li>
            <li>list item</li>
            <li>list item</li>
         </ul>
      </div>
   );
};
export default Vision;
